import React from 'react';

const ListViewLoading = ({count, layout}) => {
    const layouts = {
        'TwoRows': LayoutTwoRows,
        'ImageLeft': ImageLeft,
    }
    const LayoutElement = layouts[layout] || LayoutTwoRows;

    return <div className="divide-y divide-gray-200">
        {Array(parseInt(count)).fill().map((_, i) => {
            return <LayoutElement key={i} />
        })}
    </div>
}

const LayoutTwoRows = () => {
    return <div className="py-4 flex animate-pulse">
        <div className="ml-3 flex-1 space-y-3">
            <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4" />
                <div className="h-4 bg-gray-200 rounded w-1/2" />
            </div>
        </div>
    </div>
}

const ImageLeft = () => {
    return <div className="py-4 flex animate-pulse">
        <div className="bg-gray-200 rounded h-[75px] w-[75px]" />
        <div className="ml-3 flex-1 space-y-3">
            <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-3/4" />
                <div className="h-4 bg-gray-200 rounded w-1/2" />
            </div>
        </div>
    </div>
}

export default ListViewLoading;